import { Directive, Output, OnInit, OnDestroy } from '@angular/core';
import { ImporterService } from '@services/datasets/importer.service';
import { ImporterState } from '@interfaces/importer-state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/**
 * Sends back to the template the status of the Importer as well as the dialog that the importer was loaded from
 */
@Directive({
  selector: '[appImporterStatus]',
  exportAs: 'importerButtonSettings'
})
export class ImporterStatusDirective implements OnInit, OnDestroy {
  private ngDestroy$ = new Subject();
  @Output() buttonDisabled: boolean;
  @Output() dialogLoadedFrom: 'sim-button' | 'import-button';

  constructor(private importerService: ImporterService) {}

  ngOnInit() {
    this.dialogLoadedFrom = this.importerService.dialogLoadedFrom;

    this.importerService.importerStatus$.pipe(takeUntil(this.ngDestroy$)).subscribe(status => {
      if (status === ImporterState.fileAggregated) {
        this.buttonDisabled = false;
      } else {
        this.buttonDisabled = true;
      }
    });
  }

  ngOnDestroy() {
    this.ngDestroy$.next();
  }
}
